import _extends from "@babel/runtime/helpers/extends";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `ButtonGroup` component is used for visual grouping of several [Buttons](#!/Button) together.
 * @since 0.0.37
 */
const ButtonGroup = ({
  baseClassName = `${CLS_PREFIX}button-group`,
  className,
  children,
  innerRef,
  ...props
}) => /*#__PURE__*/React.createElement("div", _extends({
  className: classNames(baseClassName, className),
  ref: innerRef
}, props), children);

export default ButtonGroup;